export default __webpack_public_path__ + "static/media/11.bd714e6c.png";